<template>
    <div class="new-ui-panel" @click="$emit('btnDetailClick', btnArr[0])">
        <div class="new-ui-panel-header">
          <div class="img-wrap">
            <van-image width="48" height="48" lazy-load round fit="cover" :src="complete(img)" />
          </div>
          <div class="header-content">
            <h4 class="new-ui-panel-title max-one-line">{{ title }}</h4>
            <div class="btn-wrap" v-if="btnArr">
              <van-button
                  class="ht-text-assist ht-text-none-select"
                  plain
                  type="info"
                  size="mini"
                  v-for="(item, index) in btnArr"
                  :key="index"
                  @click.stop="$emit(item.event, item)"
              >
                {{ item.text }}
              </van-button>
            </div>
          </div>
          <div class="tag-flex">
            <div class="tag-wrap">
              <template v-if="tagArr">
                <van-tag v-for="(item, index) in tagArr" :key="index" :color="item.color">
                  {{ item.text }}
                </van-tag>
              </template>
              <template v-if="item && item.read">
                <van-tag
                    type="success"
                    style="margin: 0 10px; background: #04be02"
                    v-if="item.read == ' '"
                ></van-tag>
                <van-tag
                    type="success"
                    style="margin: 0 10px; background: #04be02"
                    v-else-if="item.read == '0'"
                >
                  待阅
                </van-tag>
                <van-tag v-else style="margin: 0 10px">已阅</van-tag>
              </template>
            </div>
            <template v-if="todoStatus == 'todo' || todoStatus == 'done'">
              <van-tag v-if="item.mobPrintFlag == '0' || item.mobPrintFlag == ''" class="tag-grey-deep">未导出</van-tag>
              <van-tag v-else-if="item.mobPrintFlag == '1'" class="tag-grey-light">已导出</van-tag>
            </template>
          </div>
        </div>

        <div class="new-ui-panel-content" :style="`background: linear-gradient(270deg, #FFFFFF 0%, ${contentBgColor} 100%);`">
            <div class="desc-box first-desc-box">
              <div class="desc-label">发起人</div>
              <div class="desc-value">{{item.starterName}}</div>
            </div>
            <div class="desc-box last-desc-box">
              <div class="desc-label">发起时间</div>
              <div class="desc-value">{{item.startTime}}</div>
            </div>
        </div>
        <div class="new-ui-panel-footer">
          <div class="desc-wrap" v-show="!folded" v-if="descArr">
            <div class="display-flex wrap-box" v-for="(item, index) in descArr" :key="index">
              <div class="desc-label w110 max-two-line" v-if="item.key">{{ item.key }}</div>
              <div class="desc-value" v-if="item.value">
                <a class="text-link" v-if="item.link" :href="item.link">{{ item.value }}</a>
                <div v-else-if="Array.isArray(item.value)">
                  <div v-for="annex in item.value" class="max-two-line text-link" :key="annex.physicalId">{{annex.annexName + annex.type}}</div>
                </div>
                <div v-else class="max-two-line">
                  {{ item.value }}
                </div>
              </div>
            </div>
          </div>
          <div class="arrow-wrap" @click.stop="folded = !folded" v-if="showFolder">
            <van-icon :name="folded ? 'arrow-down' : 'arrow-up'" color="#999" size="0.4rem"/>
          </div>
        </div>
    </div>
</template>

<script>
    import { Image, Tag, Button, Icon } from "vant"
    import { locationTo, complete } from "@/utils/url"
    import { fetchRgbColer } from '@/utils/commons'
    export default {
        name: "Panel",
        components: {
            [Image.name]: Image,
            [Tag.name]: Tag,
            [Button.name]: Button,
            [Icon.name]: Icon,
        },
        props: ["img", "item", "title", "descArr", "btnArr", "tagArr", "foldDesc"],
        data() {
            return {
                folded: false,
                todoStatus: '',
            }
        },
        computed: {
            showFolder() {
                return this.foldDesc && this.descArr
            },
            contentBgColor() {
              let rgb = fetchRgbColer(this.tagArr[0].color);
              return "rgba(" + rgb.join(",") + ",0.06)";
            }
        },
        created() {
            if (this.showFolder) this.folded = true
            //获取url地址
            let url = window.location.href
            //判断url中是否包含todo
            if (url.indexOf('todo') != -1) {
                this.todoStatus = 'todo'
                this.item.todo = 'todo'
            } else if (url.indexOf('done') != -1) {
                this.todoStatus = 'done'
            }
        },
        methods: {
            complete,
        },
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/css/theme/theme.scss";
    $pd8: 8px;
    $br6: 6px;
    .max-one-line{
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tag-grey-deep{
      color: #999999;
    }
    .tag-grey-light{
      color: #C9C9C9;
    }

    .new-ui-panel {

        position: relative;
        background-color: #ffffff;
        margin-bottom: $pd8;
        border-radius: $br6;
        box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.08);
        .display-flex{
          display: flex;
        }
        &-header{
          padding-bottom: 16px;
          display: flex;
          .header-content{
            flex-grow: 1;
            width: 0;
            padding-top: 16px;
            padding-right: $pd8;
          }
          .btn-wrap {
            button {
              line-height: 1;
              border: none;
              padding: 5px 7px;
              @extend .font12;
              color: #003C88;
            }
          }
          .tag-flex{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .tag-grey-deep, .tag-grey-light{
              border-radius: 4px;
              background: #F1F1F1;
              padding: 2px 6px;
              margin-right: 4px;
              justify-content: center;
            }
          }
          .tag-wrap{
            font-size: 12px;
            .van-tag {
              padding: 2px $pd8;
              border-bottom-left-radius: $br6;
              border-top-right-radius: $br6;
            }
          }
        }
        &-title{
          @extend .font14;
          margin-left: 8px;
        }
        .img-wrap {
            margin: 12px 0px 0 8px;
        }
        &-content{
          padding: 12px $pd8;
          display: flex;
        }
        &-footer{
          font-size: 12px;
          .arrow-wrap{
            text-align: center;
          }
          .van-icon {
            height: 22px;
            line-height: 22px;
          }
          .desc-wrap{
            padding: 8px 8px 0 8px;
            line-height: 16px;
            .w110{
              width: 110px;
              flex-shrink: 0;
            };
            .wrap-box{
              margin-bottom: 6px;
            }
            .desc-value{
              padding-left: $pd8;
            }
            .max-two-line {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        .desc-box{
          font-size: 12px;
          line-height: 20px;
        }
        .first-desc-box{
          width: 110px;
          border-right: 1px solid #ECECEC
        }
        .last-desc-box{
          padding-left: 14px;
          flex: 1;
        }
        .desc-label{
          color: #666666;
        }
        .desc-value{
          color: #333333;
          .text-link{
            color: #003C88;
          }
        }
    }
</style>
